import { render, staticRenderFns } from "./MortgageGuidanceTypeButton.vue?vue&type=template&id=2fc0e242&scoped=true"
import script from "./MortgageGuidanceTypeButton.vue?vue&type=script&lang=js"
export * from "./MortgageGuidanceTypeButton.vue?vue&type=script&lang=js"
import style0 from "./MortgageGuidanceTypeButton.vue?vue&type=style&index=0&id=2fc0e242&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2fc0e242",
  null
  
)

export default component.exports